import React from 'react';
import { map } from 'ramda';
import isoCountries from 'i18n-iso-countries';
import FormDropdown from 'components/FormDropdown';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';

// Register locales for browser usage
isoCountries.registerLocale(enLocale);
isoCountries.registerLocale(esLocale);
isoCountries.registerLocale(frLocale);

const countries = isoCountries.getNames('en');
const options = map(
  (cKey: string) => ({
    key: cKey,
    value: cKey,
    text: countries[cKey]
  }),
  Object.keys(countries)
);

export function useCountries() {
  return options;
}

const Countries: React.FC = props => {
  return <FormDropdown options={options} {...props} />;
};

export default Countries;
